import React, { useEffect, useState } from 'react'

// third-party imports
import Avatar from 'react-avatar';
import { BiShareAlt } from 'react-icons/bi';

// project imports
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { Link, useNavigate } from 'react-router-dom';
import ToolTip from '../../common/Tooltip/ToolTip';
import { handleDiscountedPrice } from '../../utils/course';
import { FREE, PAID } from '../../constants';
import { showToast } from '../sweet-alert/Sweetalert';
import GenericPdfViewer from '../../pages/blogMedia/GenericPdfViewerTwo';
import { TestimonialForm } from '../form/TestimonialForm';
import { useOrderContext } from '../../context/order_context';
import { useUserContext } from '../../context/user_context';
import moment from 'moment';
import ModalLogin from '../form/ModalLogin';
import { PaymentSuccessModel } from '../success-model/PaymentSuccessModel';
import EbookStarRatingV2 from './EbookStarRatingV2';
import Spinner from "../spinner-component/SpinnerOne";

// Reading env variable
const VENDOR_NAME = process.env.REACT_APP_RAZOR_APP_VENDOR_NAME;
const RAZOR_THEME = process.env.REACT_APP_RAZOR_APP_THEME_COLOR;

function EBookListingHome({ data, code, activeStatus, isFromHome }) {

    // reading context variables and methods
    const { loginData } = useUserContext();
    const {
        fetchOrders,
        orderLoading,
        createOrders,
        isPaymentSuccess,
        closePaymentSuccessModal,
        downloadEbook,
        ordersError,
    } = useOrderContext();

    const navigate = useNavigate();

    //State initialization
    const [selectedProductCode, setSelectedProductCode] = useState(null);
    const [status, setStatus] = useState(FREE);
    const [toggler, setToggler] = useState(false);
    const [showTestimonialModal, setShowTestimonialModal] = useState(false);
    const [notLoggedIn, setNotLoggedIn] = useState(false);
    const [newOrder, setNewOrder] = useState({});
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);
    const [isCopied, setIsCopied] = useState(false);

    // constant variable
    const member =
        loginData && loginData?.data && loginData?.data?.userId
            ? loginData?.data
            : [];

    // check paid E-books
    const paidEBooks = data?.pricing.price > 0 || null;

    const reviews =
        data &&
            data?.metadata &&
            data?.metadata?.ratings &&
            data?.metadata?.ratings !== "0"
            ? data?.metadata?.ratings
            : "[]";
    // this will remove the tralling commas as there is the comma that making error on pars so used this to clean the string
    let cleanString = reviews?.replace(/,\s*([}\]])/g, "$1");
    const review = JSON.parse(cleanString);

    // Get Preview URL
    const previewPath = data && data?.media && data?.media?.previewUrl ? data?.media?.previewUrl : "#";
    const filePath = `${process.env.PUBLIC_URL}/ebook-preview/${previewPath}`
    const previewName = data && data?.name ? data?.name : "Free Preview";

    const isDiscountValid = (data) => {
        try {
            if (
                data &&
                data?.discount &&
                data?.discount?.hasDiscount &&
                handleDiscountedPrice(data)?.isValid
            ) {
                return true;
            } else {
                return false;
            }
        } catch (error) {
            console.log(
                "109 : EBookTypeThree : Error in isDiscountValid : ",
                error && JSON.stringify(error),
            );
        }
    };

    const eBookAmount =
        data && isDiscountValid(data)
            ? handleDiscountedPrice(data)?.finalAmount * 100
            : data?.pricing?.priceInSmallUnit || 501;
    const eBookDiscount =
        data && isDiscountValid(data)
            ? parseFloat(data?.discount?.discountPercent || "0.00")
            : "0.00";


    const handleOpenUserReview = (productCode) => {
        try {
            // setOpenDrawer(true);
            setSelectedProductCode(productCode);
            navigate(
                `/our-resources/${activeStatus ? activeStatus : status}/${code ? code : (productCode || "")?.toLowerCase()
                }#reviews`,
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED,
            );
        } catch (error) {
            console.log(
                "186 : EBookTypeThree : Error in handleOpenDrawer : ",
                error && JSON.stringify(error),
            );
        }
    };

    const handleNavigateDetail = (data) => {
        try {
            navigate(
                `/our-resources/${activeStatus ? activeStatus : status}/${data?.productCode?.toLowerCase()}`
            );
            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DETAIL_VIEWED
            );
        } catch (error) {
            console.log(
                "89 : EBookListingOne : Error in handleOpenDrawer : ",
                error && JSON.stringify(error)
            );
        }
    };

    const togglePreviewModal = () => {
        try {
            setToggler(!toggler);
        } catch (error) {
            console.error(
                "179 : EBookTypeOne : Error occurred in togglePreviewModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the preview modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    }

    const toggleTestimonialModal = () => {
        try {
            setShowTestimonialModal(!showTestimonialModal);
        } catch (error) {
            console.error(
                "114 : TestimonialForm : Error occurred in toggleTestimonialModal:",
                error && JSON.stringify(error)
            );
            showToast(
                "error",
                "Something went wrong while toggling the testimonial modal. Please try again.",
                true,
                "bottom-right",
                false,
                true,
                5000
            );
        }
    };

    const handleDownloadBook = async (data) => {
        if (isProcessingPayment) return;

        try {
            if (!member || (member && !member?.userId)) {
                setNotLoggedIn(true);
                return;
            }

            setIsProcessingPayment(true);

            triggerFunction(
                GoogleAnalyticsEnum.BUTTON,
                GoogleAnalyticsEnum.LSA_SALESFORCE_RESOURCE_DOWNLOAD_BUTTON
            );
            const orderPayload = {
                amount: activeStatus === "free" ? 501 : eBookAmount,
                amountUnit: "paise",
                discount: eBookDiscount,
                orderCurrency: data?.pricing?.priceCurrency || "INR",
                receipt: `${activeStatus}_lsa_portal_order_${Date.now()}`,
                amountPaid: 0.0,
                createdAt: moment(new Date()).format("YYYY-MM-DD"),
                vendorName: VENDOR_NAME,
                customer: {
                    customerId: member?.firebaseUid || member?.userRecordId,
                    email: member?.userId,
                    fullName: member?.userFullName,
                },
                notes: [
                    {
                        id: data?.id,
                        productCode: data?.productCode,
                        name: data?.name,
                        type: data?.type,
                        duration: data?.pricing?.billingCycle,
                        isActive: data?.isActive,
                        category: data?.category,
                        subCategory: data?.subCategory,
                        description: "Purchase Of - " + (data?.name || ""),
                        price: eBookAmount,
                        discountPercent: eBookDiscount,
                        features: data?.features,
                        thumbnailUrl: data?.media?.thumbnailUrl || "#",
                    },
                ],
            };

            if (activeStatus === "free") {
                setNewOrder(orderPayload);
                // calling create order api
                const response = await createOrders(orderPayload);
                if (!ordersError && response !== "error") {
                    downloadEbook({
                        paymentId: response?.razorPayOrderId,
                        productId: data?.productCode,
                        productName: data?.name,
                        entityType: "free",
                    });
                }

                setIsProcessingPayment(false);
                return;
            }
            if (activeStatus === "paid") {
                // calling create order api
                const response = await createOrders(orderPayload);

                if (!ordersError && response !== "error") {
                    const options = {
                        key: process.env.REACT_APP_RAZOR_APP_KEY,
                        order_id: response?.razorPayOrderId,
                        amount: eBookAmount,
                        currency: data?.currency,
                        name: VENDOR_NAME,
                        description: "Purchase Of - " + (data?.name || ""),
                        image: process.env.REACT_APP_LOGO_URL,

                        handler: function (response) {
                            setNewOrder({
                                ...newOrder,
                                ...orderPayload,
                                paymentId: response.razorpay_payment_id,
                            });

                            downloadEbook({
                                paymentId: response?.razorpay_payment_id,
                                productId: data?.productCode,
                                productName: data?.name,
                                entityType: "",
                            });
                            //Open Testimonial Modal
                            // toggleTestimonialModal();
                            // setShowTestimonialModal((prev) => !prev);
                        },
                        // Razorpay modal is now opening
                        modal: {
                            ondismiss: function () {
                                setIsProcessingPayment(false);
                            },
                        },
                        prefill: {
                            name: member?.userFullName,
                            email: member?.userId,
                            contact: "",
                        },
                        theme: {
                            color: RAZOR_THEME,
                        },
                        notify: {
                            sms: true,
                            email: true,
                        },
                        notes: {
                            item_description: "Purchase Of - " + (data?.name || ""), // You can add item details here as well
                        },
                    };
                    const rzp = new window.Razorpay(options);
                    rzp.open();

                    // API is finished, so remove the loading state
                    setIsProcessingPayment(false);
                } else {
                    setIsProcessingPayment(false);
                }
            }
        } catch (error) {
            console.log(
                "145 : EBookListingOne : Error in handleDownloadBook : ",
                error && JSON.stringify(error)
            );
        }
    };

    const isPaymentDone = () => {
        if (isPaymentSuccess && newOrder && Object.keys(newOrder).length) {
            return true;
        }
    };

    const closeModalLogin = () => setNotLoggedIn(false);

    const closeModalPaymentSuccess = () => {
        try {
            closePaymentSuccessModal();
        } catch (error) { }
    };

    // TODO: 09242026 - Commented this
    // useEffect(() => {
    //        if (member && member?.userId) {
    //         const userUniqueId = member && ((member?.firebaseUid ? member?.firebaseUid : member?.userRecordId));

    //         fetchOrders(userUniqueId);
    //     }
    // }, [orderLoading, member]);

    const handleShare = async () => {
        // const shareUrl = window.location.href;
        const slug = data?.productCode?.toLowerCase();

        const shareUrl = `/our-resources/${activeStatus ? activeStatus : status}/${slug}`;

        const shareData = {
            title: data?.name || "Longswitch Academy",

            text: `Check out this E-Book from Longswitch Academy: ${data?.name || ""}`,

            url: shareUrl,
        };

        // Native sharing
        if (navigator.share) {
            try {
                await navigator.share(shareData);

                return;
            } catch (error) {
                if (error?.name === "AbortError") {
                    return;
                }
            }
        }

        // Clipboard fallback
        try {
            await navigator.clipboard.writeText(shareUrl);

            setIsCopied(true);

            setTimeout(() => {
                setIsCopied(false);
            }, 2000);
        } catch (error) {
            console.error("Unable to copy article link:", error);
        }
    };

    useEffect(() => {
        if (paidEBooks === true) {
            setStatus(PAID)
        }
    }, []);

    return (
        <div>
            {isProcessingPayment && <Spinner />}

            <div className="swiper-slide">


                <div className={`${isFromHome ? "thumbnail" : "ebook-thumbnail-bg rounded-4 text-center"} clickable`} onClick={() => handleNavigateDetail(data)}>
                    <img
                        className={`${isFromHome ? "w-1/1 rounded-2" : "ebook-thumbnail"}`}
                        src={`${process.env.PUBLIC_URL}/images/ebooks/${data?.media?.thumbnailUrl}`}
                        // onClick={() => handleNavigateDetail(data)}
                        alt="book"
                    />

                    {/* <div className={`center-position status-group left-top m-0 ${isFromHome ? "d-none" : ""}`}>
                        <a href={"#"} onClick={(e) => {
                            e.preventDefault();
                            setToggler(prev => !prev);
                        }} className="underline">
                            <span className="eduvibe-status status-04 badge-preview">Watch Preview</span>
                        </a>
                    </div> */}


                    {isDiscountValid(data) && (
                        <div className="wrap-resource text-center">
                            <span className="ribbon-bottom fs-5 fw-bold text-center">
                                {data?.discount?.discountPercent}% Off
                            </span>
                        </div>
                    )}
                </div>
                <div className="mt--15 mb-0 d-flex flex-wrap align-items-center justify-content-between">

                    <div className="edu-rating rating-default">

                        <EbookStarRatingV2
                            reviews={review}
                            onViewUserRatings={
                                review?.length
                                    ? () => handleOpenUserReview(data?.productCode)
                                    : null
                            }
                        />

                    </div>
                    <div className={`${isFromHome ? "d-none" : "d-flex"}`}>
                        <a
                            className="btn-transparent-2 color-primary clickable"
                            onClick={toggleTestimonialModal}
                        >
                            <i class="ri-feedback-line"></i> Add Review
                        </a>
                    </div>


                </div>
                <h6 className="title truncate-1-lines clickable mt-3 mb-3">
                    <ToolTip title={data?.name}>
                        <div
                            dangerouslySetInnerHTML={{ __html: data?.name }}
                            onClick={() => handleNavigateDetail(data)}
                        ></div>
                    </ToolTip>
                </h6>
                <div className='card-bottom card-button-bottom gap-3 mt-3'>
                    <div className={`card-bottom card-button-bottom gap-3  ${isFromHome ? "d-none" : "d-flex"} `}>
                        <button
                            className="edu-btn btn-primary btn-xl-small w-auto mx-1"
                            onClick={() => handleDownloadBook(data)}
                            disabled={isProcessingPayment}
                        >
                            Download
                        </button>
                        <ToolTip title="Share This E-Book">
                            <button
                                className="edu-btn btn-border-primary btn-xl-small "
                                onClick={handleShare}
                            >
                                {/* <span><i className="ri-share-line p-0"></i></span> */}
                            <BiShareAlt />
                            </button>
                        </ToolTip>
                    </div>

                    <div className={`${isFromHome ? "d-none" : "d-flex mt-3"}`}>

                        <button
                            className={`edu-btn btn-dark btn-xl-small w-auto ${!paidEBooks ? "d-none" : ""}`}
                            onClick={(e) => {
                                e.preventDefault();
                                setToggler((prev) => !prev);
                            }}
                        >
                            Watch Preview
                        </button>
                    </div>
                </div>

                <div className={`price-list price-style-03 mb--10 ${isFromHome ? "d-flex align-items-center justify-content-between" : "d-none"}`}>
                    <div>
                        {!data?.pricing?.price || data?.pricing?.price <= 0 ? (
                            <div className="price current-price-free">Free</div>
                        ) : (
                            <div className="price current-price">
                                {isDiscountValid(data)
                                    ? handleDiscountedPrice(data)?.formattedAmount
                                    : data?.pricing?.priceFormatted}
                            </div>
                        )}
                        {isDiscountValid(data) && (
                            <div className="price old-price">
                                {data.pricing?.priceFormatted}
                            </div>
                        )}
                    </div>
                    {/* <div> */}
                    <ToolTip title="Share This E-Book">
                        <button
                            className="edu-btn btn-border-primary btn-xl-small"
                            onClick={handleShare}
                        >
                            {/* <i className="ri-share-line p-0"></i> */}
                            <BiShareAlt />
                        </button>
                    </ToolTip>
                    {/* </div> */}
                </div>

                <div className={`border-top-1 mt--15 ${isFromHome ? "d-none" : ""}`} />
                <div className={`d-flex align-items-center justify-content-between mt--10 ${isFromHome ? "d-none" : ""}`}>
                    <div className="author-meta ">
                        <div className="author-thumb">
                            <Link
                                to={
                                    process.env.PUBLIC_URL +
                                    `/instructor-details/${process.env.REACT_APP_AUTHOR_ID}`
                                }
                            >
                                <Avatar
                                    className="custom-avatar"
                                    name={data?.metadata?.authorName}
                                    size={34}
                                    round={true}
                                    src={
                                        true
                                            ? `${process.env.PUBLIC_URL}/images/instructor/${process.env.REACT_APP_AUTHOR_IMAGE}`
                                            : ""
                                    }
                                />
                                <span className="author-title fs-15">
                                    {data?.metadata?.authorName}
                                </span>
                            </Link>
                        </div>
                    </div>

                    <div className="price-list price-style-03">
                        {!data?.pricing?.price || data?.pricing?.price <= 0 ? (
                            <div className="price current-price-free">Free</div>
                        ) : (
                            <div className="price current-price">
                                {isDiscountValid(data)
                                    ? handleDiscountedPrice(data)?.formattedAmount
                                    : data?.pricing?.priceFormatted}
                            </div>
                        )}
                        {isDiscountValid(data) && (
                            <div className="price old-price">
                                {data.pricing?.priceFormatted}
                            </div>
                        )}
                    </div>
                </div>

            </div>
            <ModalLogin
                show={notLoggedIn}
                onCloseModalLogin={closeModalLogin}
                title={"Login to proceed action"}
            />
            {isPaymentDone() && (
                <PaymentSuccessModel
                    show={isPaymentSuccess}
                    onCloseModal={closeModalPaymentSuccess}
                    response={newOrder}
                />
            )}

            {showTestimonialModal && (
                <TestimonialForm
                    show={showTestimonialModal}
                    data={data}
                    onCloseModal={toggleTestimonialModal}
                    title={"Submit Testimonial"}
                />
            )}

            <GenericPdfViewer data={{ url: filePath, title: previewName }} show={toggler} onCloseModal={togglePreviewModal} />
        </div>
    )
}

export default EBookListingHome;
